(function(){
    const body = document.querySelector('body');
    const bannerPWA = document.getElementById('bannerPWA');
    const installButton = document.getElementById('installPWA');
    const closeButton = document.getElementById('closePWA');

    // Whether we are running as an installed PWA or not.
    const isInstalledPWA = window.matchMedia('(display-mode: window-controls-overlay)').matches || window.matchMedia('(display-mode: standalone)').matches;

    if(installButton && closeButton && !isInstalledPWA) {
        let promptEvent = null

        window.addEventListener('beforeinstallprompt', e => {
            e.preventDefault();
            promptEvent = e;

            if(sessionStorage.getItem("loanBannerPWA") === null) {
                body.classList.add('pwa-show');
                bannerPWA.classList.add('banner-pwa_show');
            }

            installButton.addEventListener("click", presentAddToHome);
        });

        function presentAddToHome() {
            promptEvent.prompt();
            promptEvent.userChoice
                .then(choice => {
                    if (choice.outcome === 'accepted') {
                        body.classList.remove('pwa-show');
                        bannerPWA.classList.remove('banner-pwa_show');
                    }
                })
        }

        closeButton.addEventListener('click', function(){
            body.classList.remove('pwa-show');
            bannerPWA.classList.remove('banner-pwa_show');
            sessionStorage.setItem("loanBannerPWA", "hidden");
        });
    }
})();


